var _filter, _linearGradient, _clipPath, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyoqQuestionBank404Status(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 20,
    role: "img",
    "aria-label": "CYOQ: 404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CYOQ: 404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 20,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 31,
    height: 20,
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-hidden": "true",
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 150,
    fillOpacity: 0.8,
    filter: "url(#blur)",
    textLength: 310
  }, "CYOQ"), /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 150,
    fillOpacity: 0.3,
    textLength: 310
  }, "CYOQ")), /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 140,
    textLength: 310
  }, "CYOQ")), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-hidden": "true",
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 150,
    fillOpacity: 0.8,
    filter: "url(#blur)",
    textLength: 210
  }, "404"), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 150,
    fillOpacity: 0.3,
    textLength: 210
  }, "404")), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 140,
    textLength: 210
  }, "404")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyoqQuestionBank404Status);
export default __webpack_public_path__ + "static/media/cyoqQuestionBank404Status.61d85814097f4d2fbb94e439abfcc33e.svg";
export { ForwardRef as ReactComponent };